import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {
  StyledText,
  StyledTextSub,
} from '../../../../components/StyledTypography';
import { useTranslate } from '@im/react-localization';

export default function EditStack(
  props: Readonly<{
    label: string;
    numberText: string;
    numberValue: string | undefined;
    onClick: () => void;
    role?: boolean;
    status?: string;
  }>
) {
  const translate = useTranslate();
  return (
    <Stack>
      <Stack direction="row">
        <StyledText fontWeight={600}>
          {props.numberValue && props.numberValue !== ''
            ? props.numberValue
            : `<Select ${props.label}>`}
        </StyledText>
        <IconButton
          data-testid={`gds-vp-ss-header-edit${props.numberText}`}
          disabled={props.status === 'Deactivated'}
          onClick={props.onClick}
          sx={(theme) => ({ padding: `0 ${theme.spacing(0.5)}` })}
        >
          <EditIcon
            sx={(theme) => ({
              color:
                props.status === 'Deactivated'
                  ? 'disabled'
                  : theme.palette.primary[700],
              fontSize: theme.typography.body1.fontSize,
            })}
          />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={1}>
        <StyledTextSub>
          {translate(`VendorProgram.${props.numberText}Number`)}
        </StyledTextSub>
        {props.role && props.numberValue && (
          <Chip
            label={translate('VendorProgram.ReviewNeeded')}
            sx={(theme) => ({
              background: theme.palette.grey[100],
              borderRadius: `calc(${theme.shape.borderRadius}px - 2px)`,
              fontSize: theme.typography.caption.fontSize,
              height: '16px',
              padding: `0 ${theme.spacing(0.5)}`,
            })}
          />
        )}
        {!props.role && (
          <Chip
            label={translate('VendorProgram.EditNeeded')}
            sx={(theme) => ({
              background: theme.palette.grey[100],
              borderRadius: `calc(${theme.shape.borderRadius}px - 2px)`,
              fontSize: theme.typography.caption.fontSize,
              height: '16px',
              padding: `0 ${theme.spacing(0.5)}`,
            })}
          />
        )}
      </Stack>
    </Stack>
  );
}
